import { Component, Input, OnInit } from '@angular/core';
import { BreadcrumbService } from '../../core/service/breadcrumb.service';
import { ReportComponent } from '../../page/report/report.component';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.css'
})
export class BreadcrumbComponent implements OnInit {
  steps: any[] = []; // Local copy of the steps
  currentStep = 1;
  activeStepIndex: number = 0;
   private scrollListener: (() => void) | undefined;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private reportComponent:ReportComponent
  
  ) { }

  ngOnInit() {
    // Subscribe to the steps from the service
    this.breadcrumbService.steps$.subscribe((steps) => {
      this.steps = steps;
    });

    console.log('desktop:', this.steps);

    this.breadcrumbService.activeStepIndex$.subscribe((index: any) => {
      this.activeStepIndex = index;
    });

    console.log(this.activeStepIndex,'line no 33');

    // if(document.body.classList.contains('.breadcrumbs-container')){
    //   const header = document.querySelector('.breadcrumbs-container');
    //   this.scrollListener = () => {
  
    //     console.log('scrolling called');
    //     // Check vertical scroll position
    //     if (window.scrollY) { // Change '10' to whatever threshold you want
    //       console.log('scrolling called if');
    //       header?.classList.add('scrolled');
    //     } else {
    //       header?.classList.remove('scrolled');
    //     }
    //   };
    //   // Add the scroll event listener
    //   window.addEventListener('scroll', this.scrollListener);

    // }
    // else{
    //   console.log('else')
    // }


  }

  // Handle step click
  onStepClick(index: number) {

    console.log(index)
    // let oldSectionvalue:any=sessionStorage.getItem('oldSectionValue')
    // sessionStorage.setItem('newSectionValue',oldSectionvalue);

    // if(this.reportComponent.validateBreadCrumbSection(oldSectionvalue)){
      console.log('navigate via breadcruumb')
      
      console.log(index,"bredcrumb component selection")
  
  
      this.currentStep = index;
      this.activeStepIndex = index;
  
      // Set the active step globally
      this.breadcrumbService.updateActiveStep(index);
  
      // Perform any additional logic (e.g., scrolling to a section)
      console.log('Navigating to step:', this.steps[index].label);
  
      // sessionStorage.setItem('oldSectionValue',index.toString())

    // }
    // else{
    //      console.log('dont navigate via breadcruumb');
    // }
  }

  // Check if the connector between the active step and the next should be highlighted
  isConnectorActive(indexvalue: number): boolean {
    let retuenObj:any;
    // We want to highlight the connector only between active steps, not from the first step by default that is the reason we passing i+1 from html
   this.steps.forEach((x:any,index:number)=>{
    if(index === indexvalue){
      retuenObj=(x.active === true)?  true : false;
    }
   })
   
    // return index < this.activeStepIndex;
    return retuenObj;
  }

  splitLabel(label:any){
    const words = label.split(' ');
 
    // Handle special cases (e.g., 'information/vehicle 1')
    const firstLine = words[0];
    const secondLine = words.slice(1).join(' ');
 
    return [firstLine, secondLine];
  }
}